var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMisProyectosLittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0833C12 9.66912 11.6642 9.33333 11.25 9.33333C10.8358 9.33333 10.5 9.66912 10.5 10.0833V10.1389C10.5 10.5531 10.8358 10.8889 11.25 10.8889C11.6642 10.8889 12 10.5531 12 10.1389V10.0833ZM12 6.97222C12 6.55801 11.6642 6.22222 11.25 6.22222C10.8358 6.22222 10.5 6.55801 10.5 6.97222V7.02778C10.5 7.44199 10.8358 7.77778 11.25 7.77778C11.6642 7.77778 12 7.44199 12 7.02778V6.97222ZM13.5 12.4444H7.5V10.8889H8.22222C8.65178 10.8889 9 10.5407 9 10.1111C9 9.68156 8.65178 9.33333 8.22222 9.33333H7.5V7.77778H8.22222C8.65178 7.77778 9 7.42956 9 7C9 6.57045 8.65178 6.22222 8.22222 6.22222H7.5V4.66667H13.5V12.4444ZM6 3.11111H4.5V1.55556H6V3.11111ZM6 6.22222H4.5V4.66667H6V6.22222ZM6 9.33333H4.5V7.77778H6V9.33333ZM6 12.4444H4.5V10.8889H6V12.4444ZM3 3.11111H1.5V1.55556H3V3.11111ZM3 6.22222H1.5V4.66667H3V6.22222ZM3 9.33333H1.5V7.77778H3V9.33333ZM3 12.4444H1.5V10.8889H3V12.4444ZM7.5 3.11111V2C7.5 0.89543 6.60457 0 5.5 0H2C0.89543 0 0 0.895431 0 2V12C0 13.1046 0.895431 14 2 14H13C14.1046 14 15 13.1046 15 12V5.11111C15 4.00654 14.1046 3.11111 13 3.11111H7.5Z",
    fill: "#234BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisProyectosLittle);
export default __webpack_public_path__ + "static/media/misProyectosLittle.135971e1c9ab7d81ee2febb0e7ac1605.svg";
export { ForwardRef as ReactComponent };